import React, { useContext, useState, useEffect, useRef } from 'react';
import { NavLink, Link } from 'react-router-dom';
import './Header.css';
import api from '../../Utils/Api';
import { useCookies } from 'react-cookie';
import { CurrentUserContext } from '../../Contexts/CurrentUserContext';
import { JourneyContext } from '../../Contexts/JourneyContext';

import logo from '../../Media/Logo.png';
import HeaderButton from './HeaderButton/HeaderButton';
import HeaderMenu from './HeaderMenu/HeaderMenu';
import avatar from '../../Media/DefaultAvatar.svg';
import arrow from '../../Media/ArrowSort.svg';
import Calendar from '../../Media/Calendar.svg';
import HorizontalTree from '../App/Common/HorizontalTree/HorizontalTree';
import { Tooltip } from '@mui/material';
import HeaderTooltip from './HeaderTooltip';

const Header = ({ logOut, onCalendarClick, isCalendarVisible }) => {
    const { currentPlace, setCurrentPlace, breadCrumbs } = useContext(JourneyContext);
    const { user } = useContext(CurrentUserContext);
    const [isHeaderMenuOpened, setIsHeaderMenuOpened] = useState(false);
    const [fakeValue, setFakeValue] = useState(0);
    const [notifications, setNotifications] = useState(null);
    const [cookies, setCookie, removeCookie] = useCookies(['token']);
    const [openScrollbar, setOpenScrollbar] = useState(true);

    const gamesRef = useRef<HTMLDivElement | null>(null);
    const [token, setToken] = useState(cookies.token ? cookies.token : undefined);

    useEffect(() => {
        setFakeValue(fakeValue + 1);
    }, [user, currentPlace]);

    // console.log(breadCrumbs)
    useEffect(() => {
        Promise.all([api.getNotifications(token)])
            .then(([notifications]) => {
                // console.log(performance);
                setNotifications(notifications);
            })
            .catch((e) => {
                console.log(e);
            });
    }, []);

    useEffect(() => {
        const updateScrollbarState = () => {
            const scrollPosition = window.scrollY;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;

            if (scrollPosition + windowHeight >= documentHeight) {
                setOpenScrollbar(false);
            } else if (scrollPosition === 0) {
                setOpenScrollbar(true);
            }
        };

        window.addEventListener('scroll', updateScrollbarState);

        return () => window.removeEventListener('scroll', updateScrollbarState);
    }, []);
    
    const handleArrowClick = () => {
        setOpenScrollbar(prevState => !prevState);
    
        if (openScrollbar) {
            window.scrollBy({
                top: window.innerHeight,
                behavior: 'smooth'
            });
        } else {
            window.scroll({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    const [hasScrolled, setHasScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setHasScrolled(window.scrollY > 0);
        };

        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    
    const isValidImageExtension = (url) => {
        const regex = /\.(jpg|jpeg|png|gif|svg)$/i; // Добавлен svg
        return regex.test(url);
      };

    return (
        user && (
            <>
                <div className={`header`}>
                    <div className='header__left'>
                        <div>
                            <Link to={'/'}>
                                <img src={logo} alt='logo' />
                            </Link>
                            <HorizontalTree></HorizontalTree>
                        </div>
                        {/* <div className='header__title'>{`${currentPlace? currentPlace.title :'Личный кабинет'}`}</div> */}
                        <div className='headerMenu__info'>
                            <div
                                className='headerMenu__name'
                                onClick={() => setIsHeaderMenuOpened(true)}
                            >
                                {user.name ? `${user.name}` : 'Кристина'}
                            </div>
                            <img
                                className='header__avatar'
                                src={isValidImageExtension(user.avatar) ? user.avatar : avatar}
                                alt='avatar'
                                onClick={() => setIsHeaderMenuOpened(true)}
                            />
                        </div>
                    </div>
                    <div className='header__right'>
                    <HeaderTooltip title={'Главная'}>
                        <Link to={'/'}>
                            <HeaderButton type={'home'} />{' '}
                        </Link>
                        </HeaderTooltip>
                        <HeaderTooltip  title={'Календарь'}>
                                <Link><HeaderButton type={'calendar'} onClickAction = {onCalendarClick} active={false} title={'сalendar'} activeBtn={isCalendarVisible ? 'activeBtn' : ''} /> </Link>
                        </HeaderTooltip>
                        <HeaderTooltip title={'Мои курсы'}>
                        <Link to={'/courses'}>
                            <HeaderButton type={'courses'} />{' '}
                        </Link>
                        </HeaderTooltip>
                        <HeaderTooltip title={"Уведомления"}>
                        <Link to={'/notifications'}>
                            <HeaderButton
                                type={'notify'}
                                number={
                                    notifications !== null && notifications.length > 0
                                        ? notifications
                                        : ''
                                }
                                active={
                                    notifications !== null && notifications.length > 0
                                        ? true
                                        : false
                                }
                            />
                        </Link>
                        </HeaderTooltip>
                        <HeaderTooltip title={"Актуальные курсы"}>
                        <Link to={'/performance'}>
                            <HeaderButton type={'cap'} />
                        </Link>
                        </HeaderTooltip>
                        <HeaderTooltip title={"Все задания"}>
                        <Link to={'/current'}>
                            <HeaderButton type={'current'} />{' '}
                        </Link>
                        </HeaderTooltip>
                        <HeaderTooltip title={"Онлайн-запись"}>
                        <Link to={'/booking'}>
                            <HeaderButton type={'booking'} />
                        </Link>
                        </HeaderTooltip>
                    </div>
                </div>
                <HeaderMenu
                    isOpened={isHeaderMenuOpened}
                    onClose={setIsHeaderMenuOpened}
                    notifications={notifications}
                    logOut={logOut}
                    username={user.name}
                />
              {isCalendarVisible && <>
                {openScrollbar ? (
                    <a className='header__arrow' onClick={handleArrowClick}>
                        <img src={arrow} alt='Вниз' />
                        <img src={arrow} alt='Вниз' />
                    </a>
                    ) : (
                        <a className='header__arrow up' onClick={handleArrowClick}>
                            <img src={arrow} alt='Вверх' />
                            <img src={arrow} alt='Вверх' />
                        </a>
                    )}
              </>}
            </>
        )
    );
};
export default Header;
